import {
    GET_ALL_TRACKER_USERS_WITH_PROFILE,
    GET_ALL_USERS_WITH_PROFILE,
    SET_VERIFIED_TO_USER,
    SET_IS_ACTIVE_TO_USER,
    ADD_NOTE_TO_USER,
    REMOVE_NOTE_FROM_USER,
} from '../actions/types';

export default function (state = [], action) {
    switch (action.type) {
        case GET_ALL_TRACKER_USERS_WITH_PROFILE:
            return action.payload;
        case GET_ALL_USERS_WITH_PROFILE:
            return action.payload;
        case SET_VERIFIED_TO_USER: {
            const {ownerKey, verified} = action.payload;

            return state.map(user => {
                if (user.key === ownerKey)
                    user.verified = verified;

                return user;
            });
        }
        case SET_IS_ACTIVE_TO_USER: {
            const {ownerKey, isActive} = action.payload;

            return state.map(user => {
                if (user.key === ownerKey)
                    user.isActive = isActive;

                return user;
            });
        }
        case ADD_NOTE_TO_USER:
            return state.map(user => {
                const {ownerKey, dateAdd, text, key} = action.payload;

                if(user.key === ownerKey)
                    user.notes.push({
                        dateAdd,
                        key,
                        text,
                    });

                return user;
            });
        case REMOVE_NOTE_FROM_USER:
            return state.map(user => {
                user.notes = user.notes.reduce((array, note) => {
                    const deleteKey = action.payload;

                    if (note.key !== deleteKey)
                        array.push(note);

                    return array;
                }, []);

                return user;
            });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/app/reducers/users_reducer.js